import { downloadFile } from '@/utils/http/http.service';
import Http from '@/utils/http/index';

export default {
  /**
   * 账户详情
   */
  getAccountInfo() {
    return Http.get('/merchant/account/getMerchantInfo');
  },
};
